// src/pages/Login.js
import React from "react";
import { auth, provider } from "../firebase";
import { signInWithPopup } from "firebase/auth";

const Login = ({ onLogin }) => {
  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const userData = {
        name: user.displayName,
        email: user.email,
        photo: user.photoURL,
      };
      onLogin(userData);
    } catch (error) {
      alert("Google Sign-In failed");
      console.error("Login error:", error);
    }
  };

  return (
    <div
      style={{
        background: "linear-gradient(120deg, #1e1e60, #3b3ba3)",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <div
        style={{
          background: "rgba(255, 255, 255, 0.1)",
          padding: "40px",
          borderRadius: "20px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4)",
          backdropFilter: "blur(10px)",
          width: "90%",
          maxWidth: "400px",
          color: "#fff",
          textAlign: "center",
          animation: "fadeIn 1s ease",
        }}
      >
        <h2 style={{ marginBottom: "30px", fontSize: "24px" }}>
          ✨ Sign in to Continue
        </h2>

        <button
          onClick={handleGoogleLogin}
          style={{
            padding: "12px 20px",
            borderRadius: "10px",
            border: "none",
            background: "#ffffff20",
            color: "#fff",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            backdropFilter: "blur(4px)",
            transition: "all 0.3s ease",
          }}
          onMouseOver={(e) => {
            e.target.style.background = "#00c9a7";
            e.target.style.color = "#000";
          }}
          onMouseOut={(e) => {
            e.target.style.background = "#ffffff20";
            e.target.style.color = "#fff";
          }}
        >
          🔐 Sign in with Google
        </button>
      </div>

      {/* CSS keyframes animation */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default Login;
